import { useCallback, useState } from 'react';
import { A33, A33Input, A33Output } from 'api/U002';
import { FetchError } from 'api/API';

type GroupRegistraionDoRequest = (param: {
  request: A33Input;
  onSuccess?: (response: A33Output) => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => Promise<void>;

export function useGroupRegistraionHooks(): [GroupRegistraionDoRequest, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [err, setError] = useState<Error | null>(null);

  const createTemporaryUser = async (request: A33Input, cancellation: AbortSignal) => {
    const json = await A33(request, cancellation);
    return json;
  };

  const doRequest = useCallback<GroupRegistraionDoRequest>(
    async ({ request, cancellation, onSuccess, onError }) => {
      const controller = new AbortController();
      const cancelSignal = cancellation ?? controller.signal;
      try {
        setLoading(true);
        const result = await createTemporaryUser(request, cancelSignal);
        onSuccess?.(result);
      } catch (err) {
        console.error({ err });
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          onError?.(flooredError);
          setError(flooredError);
        } else {
          const flooredError = new Error(`unknown error. ${err}`);
          onError?.(flooredError);
          setError(flooredError);
        }
      } finally {
        setLoading(false);
      }
    },
    [createTemporaryUser, setLoading, setError]
  );

  return [doRequest, loading, err];
}
